import { Button, CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";
import { formatDate } from "../../_helpers";

export const getWbProjectColumns = ({ t,
  keyPrefix,
  i18n,
  apiRef,
  wbProjectsLinkingInfo,
  projectsForLinking,
  handleUpdateProject,
  selectedConfirmProjectId,
  confirmProjectLinkLoading,
  handleConfirmLinking,
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
    getValueForCopy: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "archivedAt":
          text = rowData?.archivedAt ?  formatDate(new Date(rowData?.archivedAt)) : ''
          break;
        case "stopped":
          text = rowData[extraData.fieldName] ? t("Stopped") : t("Active")
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
    getValueForFilter: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "archivedAt":
          text = formatDate(new Date(rowData?.archivedAt))
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
  })

  return [
    {
      download: true,
      print: true,
      field: "wbProjectName",
      headerName: t("wkb.wbProjectName"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.wbProjectName}
            cellSubMenuOptions={{ options: getOptions({ field: "wbProjectName", isQuickFilterDisplay: Boolean(rowData.wbProjectName) }), extraData: { fieldName: "wbProjectName" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "planNumber",
      headerName: t("wkb.wbProject.planNumber"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.planNumber}
            cellSubMenuOptions={{ options: getOptions({ field: "planNumber", isQuickFilterDisplay: Boolean(rowData.planNumber) }), extraData: { fieldName: "planNumber" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "projectName",
      headerName: t("settings.table.column.project.name"),
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const rowData = params.row;
        const project = wbProjectsLinkingInfo.find((p) => p.wbProjectId === rowData?.id) ||{};
        if (rowData.projectName && project?.linked) return rowData.projectName;
        return (
          <LabelColumnV2
            label={
              <FormControl variant="outlined" size="small" fullWidth>
                <Select
                  value={rowData.projectId}
                  onChange={(e) => handleUpdateProject(e, rowData?.wbProjectId)}
                  fullWidth
                >
                  {projectsForLinking.map((option) => (
                    <MenuItem key={option.projectId} value={option.projectId}>
                      {option.projectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
            cellSubMenuOptions={{ options: getOptions({ field: "projectName", isQuickFilterDisplay: Boolean(rowData.projectName) }), extraData: { fieldName: "projectName" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "projectNo",
      headerName: t("general.projectNumber"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.projectNo}
            cellSubMenuOptions={{ options: getOptions({ field: "projectNo", isQuickFilterDisplay: Boolean(rowData.projectNo) }), extraData: { fieldName: "projectNo" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "stopped",
      type: "singleSelect",
      valueOptions: [
        { value: true, label: t("Stopped") },
        { value: false, label: t("Active") },
      ],
      headerName: t("general.status"),
      flex: 1,
      minWidth: 60,
      renderCell: (params) => {
        const rowData = params.row;
        const label= rowData.stopped ? t("Stopped") : t("Active")
        return (
          <LabelColumnV2
            label={label}
            cellSubMenuOptions={{ options: getOptions({ field: "stopped", isQuickFilterDisplay: label }), extraData: { fieldName: "stopped", type: "singleSelect" } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "archivedAt",
      headerName: t('general.archivedOn'),
      flex: 1,
      minWidth: 90,
      type: "date",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2 date={rowData.archivedAt}
          cellSubMenuOptions={{ options: getOptions({ field: "archivedAt", isQuickFilterDisplay: rowData?.archivedAt }), extraData: { fieldName: "archivedAt", type: "date" } }}
          request={rowData}
        />
      },
    },
    {
      download: true,
      print: true,
      field: "wbProjectManager",
      headerName: t("wkb.wbResponsible"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.wbProjectManager}
            cellSubMenuOptions={{ options: getOptions({ field: "wbProjectManager", isQuickFilterDisplay: Boolean(rowData.wbProjectManager) }), extraData: { fieldName: "wbProjectManager" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: false,
      print: false,
      field: "confirm",
      headerName: t("general.action"),
      flex: 1,
      sortable: false,
      filterable: false,
      minWidth: 120,
      renderCell: (params) => {
        const rowData = params.row;

        const project = wbProjectsLinkingInfo.find((p) => p.wbProjectId === rowData?.id) ||
          {};

        return project.linked ? (
          t("general.linked")
        ) : (
          <Button
            disabled={
              (confirmProjectLinkLoading &&
                selectedConfirmProjectId === rowData?.projectId) ||
              !project.projectId
            }
            onClick={() => handleConfirmLinking(rowData.projectId, rowData.wbProjectId)}
            variant="outlined"
            color="primary"
            size="small"
          >
            {confirmProjectLinkLoading &&
              selectedConfirmProjectId === rowData?.projectId ? (
              <CircularProgress size={20} />
            ) : (
              t("general.confirm")
            )}
          </Button>
        );
      },
    },
  ];
}


